import request from "@/utils/request";

// 获取申请审批流程任务
export function getProcessTasksByApplicationId(applicationId) {
  return request({
    url: "/cloud/application/process/tasks?applicationId=" + applicationId,
    method: "get"
  });
}

// 获取当前用户任务审批权限
export function getUserTaskPermissionByApplicationId(applicationId) {
  return request({
    url: "/cloud/application/process/task/permission?applicationId=" + applicationId,
    method: "get"
  });
}

// 根据申请id和流程任务的功能编码，获取改任务信息
export function getProcessTaskByApplicationIdAndFuncCode(applicationId, funcCode) {
  return request({
    url: "/cloud/application/process/task?applicationId=" + applicationId + "&funcCode=" + funcCode,
    method: "get"
  });
}

// 材料初审审核
export function applicationApprove(data) {
  return request({
    url: "/cloud/application/process/approve",
    method: "post",
    data: data,
  });
}


